export enum BuildingRightsType {
    LANDLORD = "LANDLORD",
    OWNER = "OWNER",
    RENTER = "RENTER"
}
